<template>
    <div class="content">
        <p
            v-if="slotData.textContent !== null && slotData.textContent !== undefined"
            class="content-text-info"
        >
            {{ slotData.textContent }}
        </p>
        <p>{{ infotext }}</p>
        <br>
        <dynamic-table :table-data="slotData.tableData" />
        <br>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import DynamicTable from "@/components/DynamicTable.vue"
    import SearchResultModel from "@/models/searchresultmodel"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class RadioasemienKuuluvuus extends Vue {
        // Onko konponentti aktiivinen. keep-alive jättää komponentin käyntiin ja
        // searchAddressSelected event laukeaa myös deaktivoidussa komponentissa.
        active = false

        activated() {
            this.active = true
        }

        deactivated() {
            this.active = false
        }

        get searchAddressSelected(): SearchResultModel | null {
            return store.getters.searchAddressSelected
        }

        get infotext(): string | undefined {
            if (this.searchAddressSelected !== null) {
                return this.$t("App.RadioJaTV.RadioasemienKuuluvuus.RightSlot.InfoText") + " " + this.searchAddressSelected.getFullName() + "."
            }
        }

        @Watch("searchAddressSelected")
        onSearchAddressSelected(): void {
            if (this.active && store.getters.searchAddressSelected == null) {
                store.dispatch("setRightSlotData", [])
            }
        }

        get slotData(): DynamicRightSlotData | null {
            return store.getters.rightSlotData as DynamicRightSlotData
        }
    }
</script>
